import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-6 mx-auto max-w-[812px] flex flex-col gap-6" }
const _hoisted_2 = { class: "md:bg-white rounded-[20px] text-center" }
const _hoisted_3 = { class: "rounded-t-[20px] max-md:rounded-b-[20px] h-14 flex justify-center items-center bg-brown" }
const _hoisted_4 = { class: "text-white text-2xl font-semibold" }
const _hoisted_5 = { class: "md:bg-white rounded-[20px] text-center" }
const _hoisted_6 = { class: "rounded-t-[20px] max-md:rounded-b-[20px] h-14 flex justify-center items-center bg-brown" }
const _hoisted_7 = { class: "text-white text-2xl font-semibold" }
const _hoisted_8 = { class: "pb-6 md:px-10 pt-10" }
const _hoisted_9 = { class: "text-xl max-md:leading-[20px] max-md:text-left md:text-2xl font-semibold mb-4" }
const _hoisted_10 = { class: "text-xl max-md:leading-[20px] max-md:text-left md:text-2xl font-semibold mb-4 mt-6 md:mt-10" }
const _hoisted_11 = { class: "text-xl max-md:leading-[20px] max-md:text-left md:text-2xl font-semibold mb-4 mt-6 md:mt-10" }
const _hoisted_12 = { class: "md:bg-white rounded-lg text-center" }
const _hoisted_13 = { class: "rounded-t-[20px] max-md:rounded-b-[20px] h-14 flex justify-center items-center bg-brown" }
const _hoisted_14 = { class: "text-white text-2xl font-semibold" }
const _hoisted_15 = { class: "pb-6 md:px-10 pt-10" }
const _hoisted_16 = { class: "text-xl max-md:leading-[24px] max-md:text-left md:text-2xl font-semibold mb-4" }
const _hoisted_17 = { class: "md:bg-white rounded-lg text-center" }
const _hoisted_18 = { class: "rounded-t-[20px] max-md:rounded-b-[20px] h-14 flex justify-center items-center bg-brown" }
const _hoisted_19 = { class: "text-white text-2xl font-semibold" }
const _hoisted_20 = { class: "pb-6 md:px-10 pt-10" }
const _hoisted_21 = { class: "text-xl max-md:leading-[24px] max-md:text-left md:text-2xl font-semibold mb-4" }
const _hoisted_22 = { class: "text-xl max-md:leading-[24px] max-md:text-left md:text-2xl font-semibold mb-4 mt-6 md:mt-10" }


import { BaziResponse } from "@/types/calculators";
import NatalBirthdayDecktop from "@/views/Calculators/BaZiPrediction/components/NatalBirthdayDecktop.vue";
import NatalHiddenDesktop from "@/views/Calculators/BaZiPrediction/components/NatalHiddenDesktop.vue";
import NatalPalaces from "@/views/Calculators/BaZiPrediction/components/NatalPalaces.vue";
import ElementsBalance from "@/views/Calculators/BaZiPrediction/components/ElementsBalance.vue";
import DecadesOfLuck from "@/views/Calculators/BaZiPrediction/components/DecadesOfLuck.vue";
import AnnualsLuck from "@/views/Calculators/BaZiPrediction/components/AnnualsLuck.vue";
import NatalBirthdayMobile from "@/views/Calculators/BaZiPrediction/components/NatalBirthdayMobile.vue";
import NatalHiddenMobile from "@/views/Calculators/BaZiPrediction/components/NatalHiddenMobile.vue";
import NatalPalacesPillarTable from "@/views/Calculators/BaZiPrediction/components/NatalPalacesPillarTable.vue";
import { useI18n } from "vue-i18n";
import PersonalIndicators from "@/views/Calculators/BaZiPrediction/components/PersonalIndicators.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaziPredictionResult',
  props: {
    data: {},
    inputYear: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)("calculators.bazi.results.personal-indicators.title")), 1)
      ]),
      _createVNode(PersonalIndicators, {
        class: "pb-6 md:px-10 pt-10",
        "personal-indicators": __props.data.personal_indicators
      }, null, 8, ["personal-indicators"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.title")), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h4", _hoisted_9, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.four-stems")), 1),
        _createVNode(NatalBirthdayDecktop, {
          pillars: props.data.natal.pillars,
          class: "max-md:hidden"
        }, null, 8, ["pillars"]),
        _createVNode(NatalBirthdayMobile, {
          pillars: props.data.natal.pillars,
          class: "md:hidden"
        }, null, 8, ["pillars"]),
        _createElementVNode("h4", _hoisted_10, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.hidden-stems")), 1),
        _createVNode(NatalHiddenDesktop, {
          hidden: props.data.natal.hidden,
          class: "max-md:hidden"
        }, null, 8, ["hidden"]),
        _createVNode(NatalHiddenMobile, {
          hidden: props.data.natal.hidden,
          class: "md:hidden"
        }, null, 8, ["hidden"]),
        _createElementVNode("h4", _hoisted_11, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.12-palaces")), 1),
        _createVNode(NatalPalaces, {
          palaces: props.data.natal.palaces,
          pillars: props.data.natal.pillars,
          class: "max-md:hidden"
        }, null, 8, ["palaces", "pillars"]),
        _createVNode(NatalPalacesPillarTable, {
          palaces: props.data.natal.palaces,
          pillars: props.data.natal.pillars,
          class: "md:hidden"
        }, null, 8, ["palaces", "pillars"])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)("calculators.bazi.results.element-balance.title")), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(t)("calculators.bazi.results.element-balance.subtitle", {
              dayMasterStatus: props.data.day_master_status,
            })), 1),
        _createVNode(ElementsBalance, {
          data: props.data.element_balance
        }, null, 8, ["data"])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)("calculators.bazi.results.luck-flow.title")), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(t)("calculators.bazi.results.luck-flow.decade-luck-title")), 1),
        _createVNode(DecadesOfLuck, {
          "start-year": props.inputYear,
          data: props.data.decades_of_luck
        }, null, 8, ["start-year", "data"]),
        _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(t)("calculators.bazi.results.luck-flow.yearly-trend-title")), 1),
        _createVNode(AnnualsLuck, {
          years: props.data.years,
          palaces: props.data.natal.palaces
        }, null, 8, ["years", "palaces"])
      ])
    ])
  ]))
}
}

})